module.exports = __webpack_public_path__ + "a17d279f/img/note-list-icon.961c1485.svg";